<style scoped lang="scss">
    .status {
        background: #E6F1FC;
        height: 40px;
    }

    p {
        justify-content: flex-end;
    }

    .item {
        margin-top: 20px;

        h3 {
            font-size: 16px;
        }

        div {
            margin-top: 5px;
            text-indent: 2em;
        }
    }
</style>
<template>
    <div class="container bg_fff">
        <breadcrumb :pages="pages"></breadcrumb>
        <div class="pl15 pr15 pb15 pt15">
            <div class="back">
                <el-button size="mini" @click="$router.back()" type="primary">返回</el-button>
            </div>
            <h2 class="flex jcc fs20">
                影像检查报告
            </h2>
            <p class="flex fs14 color_333">CR号：DR0026054</p>
            <div class="bt color_333 fs14 pt10 mt10">
                <el-row>
                    <el-col :span="6">
                        姓名：李小姐
                    </el-col>
                    <el-col :span="6">
                        性别：女
                    </el-col>
                    <el-col :span="6">
                        年龄：23
                    </el-col>
                    <el-col :span="6">
                        门诊号：
                    </el-col>
                </el-row>
                <el-row class="mt10">
                    <el-col :span="6">
                        住院号：
                    </el-col>
                    <el-col :span="6">
                        病室：
                    </el-col>
                    <el-col :span="6">
                        床号：
                    </el-col>
                    <el-col :span="6">
                        患者编号：DR0026054
                    </el-col>
                </el-row>
                <el-row class="mt10">
                    <el-col :span="12">
                        科室：
                    </el-col>
                    <el-col :span="6">
                        送诊医生：
                    </el-col>
                    <el-col :span="6">
                        检查单号：23432434
                    </el-col>
                </el-row>
                <el-row class="mt10">
                    <el-col :span="12">
                        检查部位：腰围正侧位片
                    </el-col>
                    <el-col :span="12">
                        检查时间：2019-03-06
                    </el-col>
                </el-row>
            </div>

            <div class="item color_333">
                <h3>影像所见</h3>
                <div class="fs14">
                    腰椎轻度侧弯腰椎轻度侧弯，腰椎轻度侧弯腰椎轻度侧弯，腰椎轻度侧弯，腰椎轻度侧弯，腰椎轻度侧弯，腰椎轻度侧弯，腰椎轻度侧弯，行啊上擦拭打算大撒打算打算打算打算打算大大权威的企鹅温柔。
                </div>
            </div>

            <div class="item color_333">
                <h3>专家意见</h3>
                <div class="fs14">
                    腰椎轻度侧弯腰椎轻度侧弯，腰椎轻度侧弯腰椎轻度侧弯，腰椎轻度侧弯，腰椎轻度侧弯，腰椎轻度侧弯，腰椎轻度侧弯，腰椎轻度侧弯，行啊上擦拭打算大撒打算打算打算打算打算大大权威的企鹅温柔。
                </div>
            </div>

            <div class="item color_333">
                <h3>附图</h3>
                <div class="flex">
                    <img src="../../assets/d1.png" alt="">
                    <img src="../../assets/d2.png" alt="" class="ml30">
                </div>
            </div>

            <div class="item color_333">
                <h3>备注</h3>
                <div class="fs14"></div>
            </div>

            <el-row class="fs14 color_333 mt20">
                <el-col :span="6">
                    报告医生：李小姐
                </el-col>
                <el-col :span="6">
                    审核医生：女
                </el-col>
                <el-col :span="6">
                    签名：23
                </el-col>
                <el-col :span="6">
                    报告时间：2019-03-06
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>

  import Breadcrumb from "../../components/common/Breadcrumb";
  import {diagnoseMixin} from "../../lib/mixins/diagnose";

  export default {
    name: "DiagnoseApply",
    data() {
      return {
        form: {
          status: '1'
        }
      }
    },
    computed: {},
    components: {Breadcrumb},
    mixins: [diagnoseMixin],
    created() {

    },
    methods: {}
  }
</script>
